import React from 'react';
import PropTypes from 'prop-types';

const ContextBadge = ({ context }) => {
  if (!context || !context.pageType) {
    return null;
  }

  return (
    <div className="ai-assistant-sidebar__context-badge">
      <span className="ai-assistant-sidebar__context-dot" />
      <span>{context.pageTitle || context.pageType}</span>
    </div>
  );
};

ContextBadge.propTypes = {
  context: PropTypes.shape({
    pageType: PropTypes.string,
    pageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    pageTitle: PropTypes.string,
    data: PropTypes.object
  })
};

export default ContextBadge;
